import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';


const PrivateRoute = ({ children }) => {
    // let data = useSelector(selector=>selector)
    let token = localStorage.getItem("invtoken") || null;
    if (token == null) {
        return <Navigate to="/"/>
    }
    return children
}

export default PrivateRoute